import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Constants from "../Utilities/Constants";
import Product from "../Components/Product";
import LoadingScreen from "../Components/LoadingScreen";
import SortProducts from "../Components/SortProducts";
import { getSortedProducts } from "../Utilities/sortProducts";
import { usePageTitle } from "../Utilities/usePageTitle";


const SearchProducts = () => {
    const [products, setProducts] = useState([]);
    const { query } = useParams();
    const [isLoading, setIsLoading] = useState(false); // Start with false
    const [sortType, setSortType] = useState('default');
    usePageTitle(query ? `חיפוש: ${query}` : 'חיפוש');

    useEffect(() => {
        const fetchProducts = async () => {

            setIsLoading(true);
            try {
                const url = `${Constants.API_URL_QUERY}/${query}`;
                const response = await axios.get(url);

                setProducts(response.data);
            } catch (error) {
                console.error("Search error:", error);
                setProducts([]);
            } finally {
                setIsLoading(false); 
            }
        }
        
        if (query) {
            fetchProducts();
        }
    }, [query])

    return isLoading ? (
         <LoadingScreen loading={isLoading} message="מחפש מוצרים..." />
    ) : (
        <div className="container py-4">
            <h4>תוצאות חיפוש עבור: "{decodeURIComponent(query)}"</h4>
            <div className="d-flex flex-wrap justify-content-between mb-2">
                <p className="text-muted">{products.length} מוצרים נמצאו</p>
                <SortProducts onSortChange={setSortType} currentSort={sortType} />
            </div>
            <hr/>

            {products.length === 0 ? (
                <div className="text-center pt-5">
                    <div className="mb-4">
                        <svg width="64" height="64" fill="#6c757d" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                    </div>
                    <h3>לא נמצאו מוצרים התואמים את החיפוש</h3>
                    <p className="text-muted">"{decodeURIComponent(query)}"</p>
                </div>
            ) : (
                <div className="d-flex flex-wrap justify-content-around">
                    {getSortedProducts(products, sortType).map((product, key) => (
                        <Product product={product} key={key} />
                    ))}
                </div>
            )}
        </div>
    )
}

export default SearchProducts;
